<mat-card>
  <mat-card-header>
    <mat-card-title>Stockage</mat-card-title>
    <span></span>
    <button mat-raised-button (click)="load()">Charger</button>
    <button mat-raised-button (click)="clear()">Effacer</button>
    <!-- <button mat-raised-button (click)="clearTestData()">Effacer donné de test</button>-->
  </mat-card-header>
  <mat-card-content>
    <div>
      <p>Total: {{ stats.files }}</p>
      <p>Espace utilisé: {{ stats.useDisk | bytes }}</p>
    </div>
    <div>
      <p>Présent: {{ stats.onDisk }} ( Encrypté: {{ stats.onDiskEncrypted }} )</p>
      <p>Manquants: {{ stats.missing }}</p>

      <p>Non Référencés: {{ stats.unRef }}</p>
    </div>
  </mat-card-content>
</mat-card>
